import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import './utils/common';
import { isDev } from './utils/common';

// import * as fundebug from 'fundebug-javascript';
// import FundebugVue from 'fundebug-vue';

Vue.config.productionTip = false;
// import * as Sentry from '@sentry/vue';
// import { CaptureConsole } from '@sentry/integrations';
// if (!isDev) {
//   window._Sentry = Sentry;
//   Sentry.init({
//     Vue,
//     dsn:
//       'https://0e2c8c0281dc3b9e03dcaffc0885e49c@o4509790235656192.ingest.us.sentry.io/4509796088610816',
//     integrations: [
//       new Sentry.BrowserTracing({
//         // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//         tracePropagationTargets: [
//           /^https:\/\/xingbaidesign\.com/
//           // /^http:\/\/app\.book\.com/
//         ]
//       }),
//       new Sentry.Replay({
//         maskAllText: false,
//         blockAllMedia: false
//       }),
//       new CaptureConsole({ levels: ['warn', 'info', 'error'] })
//     ],
//     // Performance Monitoring
//     tracesSampleRate: 0.1, //  Capture 100% of the transactions
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 0.1 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   });
// }

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app');
